import { NgModule } from '@angular/core';
import { CheckoutDataAccessEagerModule } from '@checkout/data-access';
import { CheckoutFeatureEagerModule } from '@checkout/feature';

@NgModule({
  imports: [CheckoutDataAccessEagerModule, CheckoutFeatureEagerModule],
})
export class CheckoutShellEagerModule {}
